import axios from "@/utils/request"

export const getVideoList = (params) => {
  return axios.request({
    url: "snjx/videoList",
    method: "GET",
    params
  });
};

export const getVideoDetail = (params) => {
  return axios.request({
    url: "snjx/videoDetail",
    method: "GET",
    params
  });
};

export const getArticleList = (params) => {
  return axios.request({
    url: "snjx/articleList",
    method: "GET",
    params
  });
};

export const getArticleDetail = (params) => {
  return axios.request({
    url: "snjx/articleDetail",
    method: "GET",
    params
  });
};

export const saveArticleHistory = (data) => {
  return axios.request({
    url: "snjx/saveArticleHistory",
    method: "POST",
    data
  });
};

export const saveArcitleHistoryWithIntegral = (data) => {
  return axios.request({
    url: "snjx/saveArcitleHistoryWithIntegral",
    method: "POST",
    data
  });
};

export const getSchool = (params) => {
  return axios.request({
    url: "snjx/getSchool",
    method: "GET",
    params
  });
};

export const saveUser = (data) => {
  return axios.request({
    url: "snjx/saveUser",
    method: "POST",
    data
  });
};

export const getUserInfo = (params) => {
  return axios.request({
    url: "snjx/getUserInfo",
    method: "GET",
    params
  });
};

export const getPrizeList = (params) => {
  return axios.request({
    url: "snjx/prizeList",
    method: "GET",
    params
  })
}

export const saveVideoHistory = (data) => {
  return axios.request({
    url: "snjx/saveVideoHistory",
    method: "POST",
    data
  });
};

export const saveVideoHistoryWithIntegral = (data) => {
  return axios.request({
    url: "snjx/saveVideoHistoryWithIntegral",
    method: "POST",
    data
  });
};

export const myPrizeList = (params) => {
  return axios.request({
    url: "snjx/myPrizeList",
    method: "GET",
    params
  });
};

export const getIntegralHistory = (params) => {
  return axios.request({
    url: "snjx/getIntegralHistory",
    method: "GET",
    params
  });
};

export const hasLogin = (params) => {
  return axios.request({
    url: "snjx/hasLogin",
    method: "GET",
    params
  });
};

export const saveFirstLogin = (data) => {
  return axios.request({
    url: "snjx/saveFirstLogin",
    method: "POST",
    data
  })
};

export const exchangeIntegral = (data) => {
  return axios.request({
    url: "snjx/exchangeIntegral",
    method: "POST",
    data
  })
};

export const viewArticle = (data) => {
  return axios.request({
    url: "snjx/saveArticleHistoryWithIntegral",
    method: "POST",
    data
  })
}